import type { IButtonStyles } from '@fluentui/react';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppToggleButton, getKeytipString, constructKeytip } from 'owa-command-ribbon';
import type RibbonViewState from 'owa-editor-ribbonplugin-store/lib/store/schema/RibbonViewState';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { callFormatApi } from 'owa-editor/lib/utils/callFormatApi';
import { getComposeRibbonId } from 'owa-editor/lib/utils/getComposeRibbonId';
import Quote from 'owa-fluent-icons-svg/lib/icons/TextQuoteRegular';
import loc from 'owa-localize';
import { FormatControlId } from 'owa-ribbon-ids';
import createWrapper from '../util/controlOnExecuteHandler';
import { blockQuoteText } from './formatControlStrings.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';

const ITEM_TYPE_URL = 'https://schemas.microsoft.com/QuotedText';

export const getQuoteControl = computedFn(
    (
        editorViewState: EditorViewState | undefined,
        ribbonViewState: RibbonViewState | undefined,
        styles: IButtonStyles | undefined,
        tabId: number | undefined
    ): RibbonControlProps => {
        return createAppToggleButton(
            getComposeRibbonId(FormatControlId.Quote, editorViewState),
            loc(blockQuoteText),
            createWrapper(editorViewState, ribbonViewState, () =>
                callFormatApi(
                    editorViewState!,
                    'toggleBlockQuote',
                    [
                        element => {
                            element.style.borderLeft = '3px solid';
                            element.style.borderColor = '#C8C8C8';
                            element.style.paddingLeft = '1ex';
                            element.style.marginLeft = '0.8ex';
                            element.style.color = '#666666';
                            element.toggleAttribute('itemscope');
                            element.setAttribute('itemtype', ITEM_TYPE_URL);
                        },
                    ],
                    [] /* pass empty array to avoid logging */
                )
            ),
            !!ribbonViewState?.formatViewState?.isBlockQuote,
            tabId && isFeatureEnabled('mon-ribbon-keytips')
                ? constructKeytip([getKeytipString(tabId)], getKeytipString(FormatControlId.Quote))
                : undefined,
            Quote,
            undefined /* iconColor */,
            styles
        );
    }
);
